"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mediaSegmentFetcher = _interopRequireDefault(require("../fetchers/media-segment-fetcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var url = require('url');
/**
 * A Segment is a media asset that can be downloaded to facilitate playback
 */


var Segment =
/*#__PURE__*/
function () {
  function Segment() {
    _classCallCheck(this, Segment);
  }

  _createClass(Segment, [{
    key: "fetch",
    value: function fetch(onProgress) {
      var _this = this;

      this.fetchPromise = new Promise(function (resolve, reject) {
        var progressWrapper = function progressWrapper(progress) {
          _this.size = progress.size;
          _this.downloaded = progress.downloaded;
          _this.progress = progress.progress;
          progress.uri = _this.uri;

          if (onProgress) {
            onProgress(progress);
          }
        };

        _this.isDownloading = true;
        var fetcher = new _mediaSegmentFetcher.default({
          url: _this.url
        });
        fetcher.fetch(progressWrapper).then(function (res) {
          _this.size = res.length;
          _this.data = res;
          _this.isDownloading = false;
          _this.headers = fetcher.headers;
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
      return this.fetchPromise;
    }
  }, {
    key: "url",
    get: function get() {
      if (this.uri.slice(0, 4) === 'http') {
        return this.uri;
      } else {
        return url.parse([this.basePath, this.uri].join('/')).href;
      }
    }
  }]);

  return Segment;
}();

var _default = Segment;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/segments/segment.js
// module id = 187
// module chunks = 0